import { useId } from 'react';

interface NulaLogoProps {
  size?: number;
  /**
   * Retained for API compatibility with existing callers. The brand mark now
   * ships a baked-in gradient (Aurora emblem), so `color` no longer tints the
   * fill — theme-specific recoloring will be reintroduced with the new palette.
   */
  color?: string;
  className?: string;
}

/**
 * Nula brand mark — the Enso emblem with its Aurora gradient (cyan → teal →
 * sky). Square 1:1 mark; gradient is baked in (viewBox 0 0 453.52 453.46).
 */
export function NulaLogo({ size = 32, color: _color, className }: NulaLogoProps) {
  // Unique per instance so multiple logos on one page don't collide on the
  // gradient id (SVG gradient ids are document-global).
  const gradientId = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 453.52 453.46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="381.59"
          y1="376.02"
          x2="85.55"
          y2="90.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#5ec8e5" />
          <stop offset="0.49" stopColor="#72d6c9" />
          <stop offset="1" stopColor="#a6e3f2" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M226.79,0C101.76,0,0,101.71,0,226.73s101.76,226.73,226.79,226.73,226.73-101.71,226.73-226.73S351.81,0,226.79,0ZM366.56,265.66c-13.46,7.27-27.35,14.81-38.87,26.17-13.25,13.14-23.8,31.07-34.94,50.07-21.27,36.24-41.46,70.48-78.45,70.48-1.18,0-2.42,0-3.66-.11-70.16-4.2-137.62-57.5-160.4-126.75-18.15-55.08-9.69-114.68,23.26-163.36,32.2-47.65,82.92-77.05,139.13-80.6,4.04-.27,7.97-.38,11.95-.38,93.15,0,175.42,69.24,186.35,159.27,4.68,38.5-16.96,50.29-44.37,65.2Z"
      />
    </svg>
  );
}
